module.exports = __webpack_public_path__ + "img/humedad_red.e3e3cbda.svg";